import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class NextStepButton extends Vue {
    @Prop({ type: Boolean, default: true })
    block: boolean;
}
